/**
 * Single source of truth for the product's name and addresses in the client.
 * The product will eventually drop "Policy" from its name and move domains -
 * rename day is: update these values, then work docs/rename-checklist.md for
 * everything code can't reach (index.html metas, legal/editorial copy, DNS,
 * OAuth apps, the email domain, Stripe, Supabase redirect URLs).
 */
export const BRAND = {
  productName: 'Cyber Garage',
  domain: 'cybergarage.app',
  siteUrl: 'https://cybergarage.app',
  // The apex 308-redirects to www at the DNS/hosting layer (pre-existing,
  // unrelated to this app) - canonical/OG tags need the URL search engines
  // and link-preview bots actually land on, not one that immediately
  // redirects away. Everything else (CORS, the Cloudflare zone lookup,
  // Stripe/email links) keeps using siteUrl - the apex resolves fine there
  // via the redirect, and the Cloudflare zone is literally registered under
  // the apex hostname, so pointing that lookup at www would break it.
  canonicalUrl: 'https://www.cybergarage.app',
  adminUrl: 'https://admin.cybergarage.app',
  supportEmail: 'hello@cybergarage.app',
  social: {
    twitter: 'https://x.com/cybergarageapp',
    linkedin: 'https://www.linkedin.com/company/cyber-gara-app',
    github: 'https://github.com/cyberpolicygarage',
  },
};
